import { Link } from 'react-router';
import { useI18n } from '../i18n';

/** Bottom of every page: the presentation of Syndiqia and the complete user manual. */
export function AppFooter({ association = false }: { association?: boolean }) {
  const { t } = useI18n();
  return (
    <footer className="app-footer">
      <Link to="/about">{t.about}</Link>
      <span aria-hidden="true">·</span>
      <Link to={association ? '/manual?structure=association' : '/manual'}>{t.manual.title}</Link>
    </footer>
  );
}
